/**
 * Account-management HTTP do OrdersRouter — rotas de segurança/conta que NÃO
 * passam pelo SignalR: forgot/change password, upload de log, verificação e
 * concessão de acesso ao roteamento. Extraído de ordersRouter.jsx
 * (l.2806-2912) na modularização dos god-objects; corpos preservados
 * byte-a-byte, `this` → `rt` (a instância Router, passada pelo delegate).
 * Contrato pinado por __tests__/routerAccountMgmtContract.test.js (escrito
 * ANTES da extração).
 *
 * Políticas de erro (intencionais, não uniformizar):
 * - forgotPwd/changePwd: erro → null, SEM toast (o modal exibe o erro)
 * - uploadLog: erro → utilities.errorHandler + false
 * - isRouterEnabled: erro → THROW com mensagem de serviço (caller distingue
 *   "não habilitado" de "serviço indisponível"); marketdata offline → false
 * - grantRouterAccess: erro → false; marketdata offline → false
 */
import * as utilities from "./utilites.jsx";
import marketdata from "./marketdata.jsx";

export const forgotPwd = async (rt, broker, userid, cpf) => {
  var tokenUrl = rt.getUrl() + "/api/security/up";
  var parameters = {
    Broker: broker,
    BrokerClientId: userid,
    CPF: cpf,
  };
  try {
    const resp = await utilities.postJsonToURL(tokenUrl, parameters, undefined);
    return resp;
  } catch (e) {
    // Don't show toast here - let the modal handle error display
    console.error("forgotPwd error:", e);
    return null;
  }
};

export const changePwd = async (rt, broker, userid, currentPwd, newPwd) => {
  var tokenUrl = rt.getUrl() + "/api/security/cp";
  var parameters = {
    Broker: broker,
    BrokerClientId: userid,
    OldBrokerClientPwd: currentPwd,
    NewBrokerClientPwd: newPwd,
  };
  try {
    const resp = await utilities.postJsonToURL(tokenUrl, parameters, undefined);
    return resp;
  } catch (e) {
    // Don't show toast here - let the modal handle error display
    console.error("changePwd error:", e);
    return null;
  }
};

export const uploadLog = async (rt, broker, userid, _log) => {
  var tokenUrl = rt.getUrl() + "/api/log/update";
  var parameters = {
    Broker: broker,
    BrokerClientId: userid,
    Log: JSON.stringify(_log),
  };
  try {
    const resp = await utilities.postJsonToURL(tokenUrl, parameters, undefined);
    return resp == "OK";
  } catch (e) {
    utilities.errorHandler(e);
    return false;
  }
};

export const isRouterEnabled = async (rt, userid) => {
  var tokenUrl = rt.getUrl() + "/api/security/isEnabled";
  if (marketdata && marketdata.state == "online") {
    try {
      const resp = await utilities.postJsonToURL(
        tokenUrl,
        { BrokerClientId: userid },
        undefined,
      );
      return resp == "OK";
    } catch (e) {
      console.error("Error checking router access:", e);
      // Throw error instead of returning false so caller can distinguish
      // between "user not enabled" vs "service unavailable"
      throw new Error(
        "Não foi possível conectar ao serviço de roteamento. Tente novamente mais tarde.",
      );
    }
  }
  // Return false when marketdata is offline (user should connect first)
  return false;
};

export const grantRouterAccess = async (rt, broker, request) => {
  var tokenUrl = rt.getUrl() + "/api/security/ga";
  var pars = {
    Broker: broker,
    BrokerClientId: request.user,
    Name: request.username,
    CPF: request.cpf,
    email: request.email,
    Phone: request.tel,
  };
  if (marketdata && marketdata.state == "online") {
    try {
      const resp = await utilities.postJsonToURL(tokenUrl, pars, undefined);
      return resp == "OK";
    } catch (e) {
      console.error("Error granting router access:", e);
      return false;
    }
  }
  return false;
};
